import React from 'react'

import Script from 'dangerous-html/react'
import PropTypes from 'prop-types'

import './hero17.css'

const Hero17 = (props) => {
  return (
    <div className="hero17-header78">
      <div className="hero17-column thq-section-padding thq-section-max-width">
        <div className="hero17-container">
          <span className="hero17-text">{props.text}</span>
          <div className="hero17-content">
            <h1 className="hero17-text1 thq-heading-1">{props.heading1}</h1>
            <p className="hero17-text2 thq-body-large">{props.content1}</p>
          </div>
          <div className="hero17-actions">
            <a href="#Kontakty" className="hero17-button thq-button-filled">
              <span className="hero17-text3 thq-body-small">
                {props.action1}
              </span>
            </a>
          </div>
        </div>
      </div>
      <div>
        <div className="hero17-container2">
          <Script
            html={`<style>
  @keyframes scroll-x {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(calc(-100% - 16px));
    }
  }

  @keyframes scroll-y {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(calc(-100% - 16px));
    }
  }
</style>
`}
          ></Script>
        </div>
      </div>
      <div className="hero17-container3"></div>
    </div>
  )
}

Hero17.defaultProps = {
  image7Src:
    'https://images.unsplash.com/photo-1619865105948-0b5ca3f5a2d9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0Mnw&ixlib=rb-4.0.3&q=80&w=1080',
  image6Alt: 'Hero Image',
  imageAlt2: 'image',
  image11Src:
    'https://images.unsplash.com/photo-1494438639946-1ebd1d20bf85?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0MXw&ixlib=rb-4.0.3&q=80&w=1080',
  imageSrc: 'https://play.teleporthq.io/static/svg/default-img.svg',
  imageSrc1: 'https://play.teleporthq.io/static/svg/default-img.svg',
  action2: 'Learn More',
  imageAlt1: 'image',
  image9Src:
    'https://images.unsplash.com/photo-1619865105948-0b5ca3f5a2d9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0M3w&ixlib=rb-4.0.3&q=80&w=1080',
  image5Alt: 'Hero Image',
  content1:
    'Čísla nás provází nejen při narození, ale také celým naším životem. Dokážou Vám ukázat, jakým směrem se máte v životě vydat, co pochopit, čím se máte zabývat a čemu máte věnovat větší pozornost než obvykle.',
  image7Alt: 'Hero Image',
  text: 'Numerologie Ivana Šulcová',
  image3Alt: 'Hero Image',
  image12Src:
    'https://images.unsplash.com/photo-1556557753-4d7eb13e06c4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0Mnw&ixlib=rb-4.0.3&q=80&w=1080',
  image12Alt: 'Hero Image',
  image9Alt: 'Hero Image',
  image1Alt: 'Numerology Hero Image',
  image8Src:
    'https://images.unsplash.com/photo-1703733569670-f36996a8ca1d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0M3w&ixlib=rb-4.0.3&q=80&w=1080',
  imageAlt3: 'image',
  image3Src:
    'https://images.unsplash.com/photo-1515275844947-c28f9c617443?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0MXw&ixlib=rb-4.0.3&q=80&w=1080',
  image2Alt: 'Hero Image',
  image6Src:
    'https://images.unsplash.com/photo-1518620859528-4f8586c03348?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0Mnw&ixlib=rb-4.0.3&q=80&w=1080',
  image4Src:
    'https://images.unsplash.com/photo-1664854953181-b12e6dda8b7c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0N3w&ixlib=rb-4.0.3&q=80&w=1080',
  image10Alt: 'Hero Image',
  image11Alt: 'Hero Image',
  image10Src:
    'https://images.unsplash.com/photo-1578654572442-a78fa88a8d35?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0N3w&ixlib=rb-4.0.3&q=80&w=1080',
  imageSrc3: 'https://play.teleporthq.io/static/svg/default-img.svg',
  imageSrc2: 'https://play.teleporthq.io/static/svg/default-img.svg',
  image5Src:
    'https://images.unsplash.com/photo-1531768758921-efe347c05370?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0Nnw&ixlib=rb-4.0.3&q=80&w=1080',
  image8Alt: 'Hero Image',
  image4Alt: 'Hero Image',
  action1: 'Domluvit Konzultaci',
  image2Src:
    'https://images.unsplash.com/photo-1664854953181-b12e6dda8b7c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0MXw&ixlib=rb-4.0.3&q=80&w=1080',
  imageAlt: 'image',
  heading1: 'Tvorba numeroskopu, rozbor data narození a vztahů',
  image1Src:
    'https://images.unsplash.com/photo-1622547748225-3fc4abd2cca0?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDI3ODU0N3w&ixlib=rb-4.0.3&q=80&w=1080',
}

Hero17.propTypes = {
  image7Src: PropTypes.string,
  image6Alt: PropTypes.string,
  imageAlt2: PropTypes.string,
  image11Src: PropTypes.string,
  imageSrc: PropTypes.string,
  imageSrc1: PropTypes.string,
  action2: PropTypes.string,
  imageAlt1: PropTypes.string,
  image9Src: PropTypes.string,
  image5Alt: PropTypes.string,
  content1: PropTypes.string,
  image7Alt: PropTypes.string,
  text: PropTypes.string,
  image3Alt: PropTypes.string,
  image12Src: PropTypes.string,
  image12Alt: PropTypes.string,
  image9Alt: PropTypes.string,
  image1Alt: PropTypes.string,
  image8Src: PropTypes.string,
  imageAlt3: PropTypes.string,
  image3Src: PropTypes.string,
  image2Alt: PropTypes.string,
  image6Src: PropTypes.string,
  image4Src: PropTypes.string,
  image10Alt: PropTypes.string,
  image11Alt: PropTypes.string,
  image10Src: PropTypes.string,
  imageSrc3: PropTypes.string,
  imageSrc2: PropTypes.string,
  image5Src: PropTypes.string,
  image8Alt: PropTypes.string,
  image4Alt: PropTypes.string,
  action1: PropTypes.string,
  image2Src: PropTypes.string,
  imageAlt: PropTypes.string,
  heading1: PropTypes.string,
  image1Src: PropTypes.string,
}

export default Hero17
